import { DOCUMENT } from '@angular/common';
import { LoadingScreenService } from './../../services/loading.service';
import { Subscription } from 'rxjs';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit, OnDestroy {

  loading: boolean = false;
  loadingSubscription: Subscription;

  constructor(
    private loadingScreenService: LoadingScreenService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    this.loadingSubscription = this.loadingScreenService.loadingStatus.pipe(
      debounceTime(150)
    ).subscribe((value: boolean) => {
      this.loading = value;
      this.toggleBodyScroll(value);
    });
  }

  ngOnDestroy(): void {
    this.toggleBodyScroll(false);
    this.loadingSubscription.unsubscribe();
  }

  private toggleBodyScroll(disabled: boolean): void {
    this.document.documentElement.classList.toggle('app-loading-active', disabled);
    this.document.body.classList.toggle('app-loading-active', disabled);
  }

}
